import { Event } from "@markit/common.types";
import { useCallback, useState } from "react";
import StandardBorderedContainer from "../../../Containers/StandardBorderedContainer";
import { Icon } from "@iconify/react";
import { Colors } from "../../../../utils/colors";
import RectangleButton from "../../../Buttons/RectangleButton";
import {
  MassTextSelectedType,
  MassTextsWrapperType,
} from "../../MassTexts/MassTextWrapperManager";
import MassTextPanel from "../../MassTexts/MassTextPanel";
import EmptyStateButton from "../../../Buttons/EmptyStateButton";
import { HorizontalDivider } from "../../../Dividers/HorizontalDivider";
import ShareLinkOptions from "../../../Share/ShareLinkOptions";
import { getShareDomain } from "../../../../utils/shareLink";

type CreateProductPublishedProps = {
  productDataSettings: Event;
};

const CreateProductPublished = (props: CreateProductPublishedProps) => {
  const { productDataSettings } = props;
  const [selectedTextType, setSelectedTextType] =
    useState<MassTextSelectedType>({ massText: undefined, isVisible: false });

  const promoteOnPress = useCallback(() => {
    setSelectedTextType({
      massText: undefined,
      isVisible: true,
    });
  }, []);

  return (
    <>
      <div className="ColumnNormal" style={{ gap: 24, marginInline: "auto" }}>
        <EmptyStateButton
          title={`${productDataSettings.eventType} Successfully Published!`}
          description="Share and promote your product"
          icon={
            <Icon
              icon="ion:bag-check"
              height={60}
              style={{ color: Colors.GREEN2 }}
            />
          }
          iconBackgroundColor={Colors.WHITE}
          iconBox={90}
        />
        <StandardBorderedContainer
          containerStyles={{
            paddingBlock: 14,
            borderRadius: 20,
            backgroundColor: Colors.WHITE1,
            width: 366,
          }}
        >
          <div className="ColumnNormal" style={{ gap: 14 }}>
            <span className="bodyMedium" style={{ paddingInline: 14 }}>
              Share Your Product
            </span>
            <HorizontalDivider />
            <div style={{ paddingInline: 14 }}>
              <ShareLinkOptions
                link={`${getShareDomain()}/e/${productDataSettings.id}`}
              />
            </div>
            <HorizontalDivider />
            <div
              className="AlignedRowSpaced"
              style={{ paddingInline: 14, gap: 10 }}
            >
              <RectangleButton
                buttonLabel="View Product"
                onPress={() =>
                  window.open(
                    `${getShareDomain()}/e/${productDataSettings.id}`,
                    "_blank"
                  )
                }
                altColor={Colors.WHITE}
                altTextColor={Colors.BLACK}
                containerStyles={{
                  padding: 14,
                  border: `0.5px solid ${Colors.GRAY2}`,
                }}
                iconRight={
                  <Icon
                    icon="ion:arrow-forward"
                    height={17}
                    style={{
                      color: Colors.BLACK,
                      transform: "rotateY(0deg) rotate(-45deg)",
                    }}
                  />
                }
              />
              <RectangleButton
                buttonLabel="Send Text"
                onPress={promoteOnPress}
                altColor={Colors.BLACK}
                altTextColor={Colors.WHITE}
                containerStyles={{ padding: 14 }}
                iconRight={
                  <Icon
                    icon="ion:paper-plane"
                    height={17}
                    style={{ color: Colors.WHITE }}
                  />
                }
              />
            </div>
          </div>
        </StandardBorderedContainer>
      </div>
      {selectedTextType.isVisible ? (
        <MassTextPanel
          wrapperType={MassTextsWrapperType.MODAL}
          selectedTextType={selectedTextType}
          setSelectedTextType={setSelectedTextType}
          campaign={undefined}
        />
      ) : null}
    </>
  );
};

export default CreateProductPublished;
